var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userSession.loggedIn)?_c('header',{staticClass:"py-3 px-4"},[_c('sos-button',{attrs:{"color":"transparent","size":"regular","buttonLabel":"Sair","buttonIcon":"mdi-exit-to-app","buttonIconSize":"20"},on:{"buttonClick":_vm.doLogout}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }